/**
 * Loans（侧栏 /app/active-loans value=loans；Management 菜单 Loans value=mgmt_loans）。
 * 打开页面打 STATSIG.COMMON.VIEW。
 *
 * 当前页面在用的功能：
 * - Create new loan：手动 / MISMO / 复制申请链接
 * - 贷款列表 / 待办：打开贷款、分配成员、归档
 *
 * 已注释、不算在用：Email 列、Target Closing Date、Processor 筛选、只看分配给我的
 */
export enum LoansEvent {
    /**
     * Create new loan 的按钮交互（打开下拉 / 点选项）。
     * value=click_open_dropdown|link|create_manually|mismo_file
     * metadata.type / metadata.method 与原来一致，用词跟 value 相同
     */
    CREATE_NEW_LOAN_BUTTON = 'LOANS_CREATE_NEW_LOAN_BUTTON',
    /**
     * 一笔贷款真正入库。
     * value=create_manually|mismo_file
     * metadata.type=insert，metadata.method 与 value 相同
     */
    LOAN_INSERT = 'LOANS_LOAN_INSERT',
    /** 打开一笔贷款。value=loan_id；metadata.source=list|popup；metadata.target_link=/app/borrower/:loan_id */
    LOAN_OPEN = 'LOANS_LOAN_OPEN',
    /**
     * 分配成员。单笔或批量都打一次。
     * value 与 metadata.type 相同：single|multiple
     * metadata.count=操作了几笔；metadata.loan_ids=对应 loan_id 列表
     */
    LOAN_ASSIGN = 'LOANS_LOAN_ASSIGN',
    /**
     * 归档 / 取消归档。单笔或批量都打一次。
     * value 与 metadata.type 相同：single|multiple
     * metadata.count=操作了几笔；metadata.loan_ids=对应 loan_id 列表
     */
    LOAN_ARCHIVE = 'LOANS_LOAN_ARCHIVE',
}
